if (typeof TestimonialsCarousel === 'undefined') {
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.autoplayDelay = this.hasAttribute('data-autoplay-delay')
        ? parseInt(this.getAttribute('data-autoplay-delay'), 10)
        : false;
      this.swiper = null;
    }

    connectedCallback() {
      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer || this.swiper) return;

      whenReady('Swiper', () => {
        try {
          const paginationEl = this.querySelector('.swiper-pagination');
          const modules = [Swiper.A11y, Swiper.EffectFade];

          if (this.autoplayDelay) {
            modules.push(Swiper.Autoplay);
          }
          if (paginationEl) {
            modules.push(Swiper.Pagination);
          }

          this.swiper = new Swiper(swiperContainer, {
            a11y: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            autoHeight: true,
            autoplay: this.autoplayDelay
              ? {
                  delay: this.autoplayDelay,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
            modules,
            pagination: paginationEl
              ? {
                  el: paginationEl,
                  type: 'bullets',
                  clickable: true,
                }
              : undefined,
          });

          // Keep the swiper frame solid during cross-fades so the page bg can’t bleed through
          const syncFrameBg = () => {
            const active = this.swiper.slides[this.swiper.activeIndex];
            const color =
              active?.dataset?.bgColor ||
              getComputedStyle(active || document.body).backgroundColor;
            swiperContainer.style.backgroundColor = color;
          };
          syncFrameBg();
          this.swiper.on('slideChange', syncFrameBg);
          this.swiper.on('slideChangeTransitionEnd', syncFrameBg);
        } catch (error) {
          console.error('Failed to initialize Testimonials Swiper:', error);
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        // cleanStyles=false — never strip merchant-authored slide styles
        this.swiper.destroy(true, false);
        this.swiper = null;
      }
    }
  }

  if (!window.customElements.get('testimonials-carousel')) {
    window.customElements.define('testimonials-carousel', TestimonialsCarousel);
  }
}
